/* ================================================== */
/* FUNCTIONS
/* ================================================== */

function giftInit(){
	setTimeout(function(){
		$('.gift__image').addClass('open');
	}, 1000);
}

/* ================================================== */
/* DOCUMENT READY
/* ================================================== */

$(document).ready(function(){

	// -- Gift init -- 
	giftInit();


	// -- Gift close --
	$('.gift__close').on('click', function(e){
		$('.gift__image').removeClass('open');
		setTimeout(function(){
			$('.gift').animate({'right': '-100%'});
		}, 250);
	});

	// -- Gift stripe close --
	$('.gift__stripe__close').on('click', function(e){
		$('.gift__stripe').removeClass('open');
	});

	// Gift onClick event
	$('.gift .gift__inner, .gift .gift__image').on('click', function(){
		$('.gift__stripe').addClass('open');
	});


});



/* ================================================== */
/* WINDOW SCROLL
/* ================================================== */

$(window).on('scroll resize orientationchange', function(){
	var windowScrollPos = $(this).scrollTop();
	var mainPos = $('main').offset().top;
	if (windowScrollPos >= mainPos) {
		$('.gift__image').removeClass('open');
	} else {
		$('.gift__image').addClass('open');
	}
});
